import * as React from "react";
import { Col } from "react-bootstrap";

export default Col;
